// Customizable Area Start
import React, { Component } from "react";
import { Box, Typography, styled } from "@mui/material";

const Wrapper = styled(Box)({
  height: "400px",
  borderRadius: "20px",
  padding: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "2px solid #652784",
  boxShadow: "0px 4px 8px 0px #00000008",
});

const Message = styled(Typography)({
  fontSize: "1.6em",
  fontWeight: 500,
  textAlign: "center",
  color: "#94A3B8",
  whiteSpace: "pre-line",
  "@media (max-width: 768px)": {
    fontSize: "1.4rem",
  },
  "@media (max-width: 414px)": {
    fontSize: "1.2rem",
  },
});

interface IProps {
  icon?: React.ReactNode;
  message: string;
  resultsLength: number;
  wrapperMargin?: string;
  children: React.ReactNode;
}

class CustomEmptyResultInfo extends Component<IProps> {
  render() {
    const { icon, resultsLength, wrapperMargin, message, children } =
      this.props;
    return resultsLength > 0 ? (
      children
    ) : (
      <Wrapper margin={wrapperMargin}>
        {icon}
        <Message>{message}</Message>
      </Wrapper>
    );
  }
}

export default CustomEmptyResultInfo;
// Customizable Area End
